"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("./facebook-emojis.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FacebookEmoji = function (_Component) {
  _inherits(FacebookEmoji, _Component);

  function FacebookEmoji() {
    _classCallCheck(this, FacebookEmoji);

    return _possibleConstructorReturn(this, (FacebookEmoji.__proto__ || Object.getPrototypeOf(FacebookEmoji)).apply(this, arguments));
  }

  _createClass(FacebookEmoji, [{
    key: "render",
    value: function render() {
      var Emoji = emojis["like"];
      if (this.props.hasOwnProperty('type')) {
        Emoji = emojis[this.props.type] ? emojis[this.props.type] : emojis["like"];
      }
      return _react2.default.createElement(
        "div",
        { id: "zama-emoji" },
        _react2.default.createElement(Emoji, { size: this.props.size })
      );
    }
  }]);

  return FacebookEmoji;
}(_react.Component);

exports.default = FacebookEmoji;


var emojis = {
  like: function like(props) {
    return _react2.default.createElement(
      "div",
      { className: 'zama-emoji emoji--like ' + (props.size ? props.size : 'md') },
      _react2.default.createElement(
        "div",
        { className: "emoji__hand" },
        _react2.default.createElement("div", { className: "emoji__thumb" })
      )
    );
  },

  love: function love(props) {
    return _react2.default.createElement(
      "div",
      { className: 'zama-emoji emoji--love ' + (props.size ? props.size : 'md') },
      _react2.default.createElement("div", { className: "emoji__heart" })
    );
  },

  haha: function haha(props) {
    return _react2.default.createElement(
      "div",
      { className: 'zama-emoji emoji--haha ' + (props.size ? props.size : 'md') },
      _react2.default.createElement(
        "div",
        { className: "emoji__face" },
        _react2.default.createElement("div", { className: "emoji__eyes" }),
        _react2.default.createElement(
          "div",
          { className: "emoji__mouth" },
          _react2.default.createElement("div", { className: "emoji__tongue" })
        )
      )
    );
  },
  yay: function yay(props) {
    return _react2.default.createElement(
      "div",
      { className: 'zama-emoji emoji--yay ' + (props.size ? props.size : 'md') },
      _react2.default.createElement(
        "div",
        { className: "emoji__face" },
        _react2.default.createElement("div", { className: "emoji__eyebrows" }),
        _react2.default.createElement("div", { className: "emoji__mouth" })
      )
    );
  },
  wow: function wow(props) {
    return _react2.default.createElement(
      "div",
      { className: 'zama-emoji emoji--wow ' + (props.size ? props.size : 'md') },
      _react2.default.createElement(
        "div",
        { className: "emoji__face" },
        _react2.default.createElement("div", { className: "emoji__eyebrows" }),
        _react2.default.createElement("div", { className: "emoji__eyes" }),
        _react2.default.createElement("div", { className: "emoji__mouth" })
      )
    );
  },
  sad: function sad(props) {
    return _react2.default.createElement(
      "div",
      { className: 'zama-emoji emoji--sad ' + (props.size ? props.size : 'md') },
      _react2.default.createElement(
        "div",
        { className: "emoji__face" },
        _react2.default.createElement("div", { className: "emoji__eyebrows" }),
        _react2.default.createElement("div", { className: "emoji__eyes" }),
        _react2.default.createElement("div", { className: "emoji__mouth" })
      )
    );
  },
  angry: function angry(props) {
    return _react2.default.createElement(
      "div",
      { className: 'zama-emoji emoji--angry ' + (props.size ? props.size : 'md') },
      _react2.default.createElement(
        "div",
        { className: "emoji__face" },
        _react2.default.createElement("div", { className: "emoji__eyebrows" }),
        _react2.default.createElement("div", { className: "emoji__eyes" }),
        _react2.default.createElement("div", { className: "emoji__mouth" })
      )
    );
  }
};